import apiClient from "@/app/api/client";
import type { PaginatedApiResponse, PaginatedData } from "@/shared/types/pagination";
import type { CreateRoleInput, ManagedRole, ResourceDescriptor, UpdateRoleInput } from "../types";

interface SingleRoleResponse {
	success: true;
	data: ManagedRole;
}

interface PermissionsResponse {
	success: true;
	data: { resources: ResourceDescriptor[] };
}

export const rolesService = {
	/** Rollar kam — bitta sahifa (`limit` backend maksimumi 100). */
	async listAll(limit: number): Promise<PaginatedData<ManagedRole>> {
		const response = await apiClient.get<PaginatedApiResponse<ManagedRole>>("/roles", {
			params: { page: 1, limit },
		});
		return response.data.data;
	},

	async listResources(): Promise<ResourceDescriptor[]> {
		const response = await apiClient.get<PermissionsResponse>("/roles/permissions");
		return response.data.data.resources;
	},

	async getById(id: string): Promise<ManagedRole> {
		const response = await apiClient.get<SingleRoleResponse>(`/roles/${id}`);
		return response.data.data;
	},

	async create(input: CreateRoleInput): Promise<ManagedRole> {
		const response = await apiClient.post<SingleRoleResponse>("/roles", input);
		return response.data.data;
	},

	async update(id: string, input: UpdateRoleInput): Promise<ManagedRole> {
		const response = await apiClient.patch<SingleRoleResponse>(`/roles/${id}`, input);
		return response.data.data;
	},

	async remove(id: string): Promise<void> {
		await apiClient.delete(`/roles/${id}`);
	},
};
